<template>
  <div>
    <h1>Stundendetails {{ year }}</h1>
    <div>
      Jahr auswählen
      <select @change="onChange($event)">
        <option v-for="y in years" :value="y">
          {{ y }}
        </option>
      </select>
    </div>

    <h3 v-if="dataLoaded">{{ user.name }}</h3>
    <h3 v-else>...</h3>
    <table class="table">
      <tr>
        <td>Vorherige Jahre Stunden: {{ (totalHoursDifference).toFixed(2) }}</td>
      </tr>
      <tr>
        <td>Monat (Von-Bis)</td>
        <td>Arbeitsstunden</td>
        <td>Saldo</td>
      </tr>
      <tr v-if="dataLoaded" v-for="(month, index) in months" :key="month.start.format('yyyy-MM-DD')">
        <td><router-link
            :to="{ path: '/users/userHoursDateRange', query: { from: month.start.format('yyyy-MM-DD'), to: month.end.format('yyyy-MM-DD'), userId: user.id } }"
            class="btn btn-info">{{ month.start.format("MMMM") }}
            ({{ month.start.format('DD.MM.') }}-{{ month.end.format('DD.MM.') }})</router-link></td>
        <td>
          <userRequiredHours :user="user" :from="month.start" :to="month.end" :index="month.index" :showSum="false"
            @carryOverCalculated="carryOverCalculated" :carryOver="month.carryOver" />
        </td>
        <td>
          <template v-if="month.carryOver > 0">
            +
          </template>
          {{ (month.carryOver).toFixed(2) }}
        </td>
      </tr>
      <tr v-else>...</tr>
    </table>
    <div v-if="overtimeData.length > 0">
      <hr style="border: 1px solid">
      <table class="table">
        <tr>
          <td>Date</td>
          <td  width="250">Comment</td>
          <td>Paid Overtime(hrs)</td>
        </tr>
        <tr v-for="data in overtimeData" :key="data.id">
          <td>{{ data.markedOn }}</td>
          <td>{{ data.comment }}</td>
          <td>{{ data.hoursPaid }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import axios from "axios";
import moment from "moment";
import UserRequiredHours from "./userRequiredHours";


export default {
  components: {
    UserRequiredHours
  },
  name: "userHourDetails",
  data() {
    var months = [];
    var years = [];
    for (var y = moment().year(); y >= 2017; y--) {
      years.push(y);
    }
    var year = years[0];
    var currentMonthIndex = 12;
    if (year == moment().year()) {
      currentMonthIndex = moment().month() + 1;
    }
    for (var i = 1; i <= currentMonthIndex; i++) {
      var dateString = year + "-" + i + "-1";
      var month = moment(dateString);
      var end = moment(dateString).endOf("month");
      if (i == currentMonthIndex && year == moment().year()) {
        end = moment();
      }
      months.push({ start: month, end: end, index: i, carryOver: 0 });
    }

    return {
      year: year,
      years: years,
      months: months,
      userId: "",
      totalHoursDifference: 0,
      user: null,
      dataLoaded: false,
      currentMonthIndex: currentMonthIndex,
      overtimeData: [],
      editEnabled: false,
    };
  },
  methods: {
    carryOverCalculated(sourceIndex, carryOver, prevYearDifference = false) {
      console.log("Month", sourceIndex, "has a carryover of", carryOver);
      for (var i = sourceIndex - 1; i <= 12; i++) {
        if (this.months[i]) {
          this.months[i].carryOver += carryOver;
        }
      }

      if (prevYearDifference) {
        this.totalHoursDifference = carryOver;
      }
    },
    onChange(event) {
      this.totalHoursDifference = 0;
      this.year = event.target.value;

      this.months = [];
      var currentMonthIndex = 12;
      if (this.year == moment().year()) {
        currentMonthIndex = moment().month() + 1;
      }
      for (var i = 1; i <= currentMonthIndex; i++) {
        var dateString = this.year + "-" + i + "-1";
        var month = moment(dateString);
        var end = moment(dateString).endOf("month");
        if (i == currentMonthIndex && this.year == moment().year()) {
          end = moment();
        }
        this.months.push({ start: month, end: end, index: i, carryOver: 0 });
      }
    }
  },
  mounted() {
    //Load users
    this.userId = this.$route.query.userId;

    axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "user/getByUserId?userid=" + this.userId }).then(result => {
      this.user = result.data;
      this.dataLoaded = true;
    }, error => {
      console.error(error);
      this.dataLoaded = false;
      if (error.response.status == 401) {
        this.$router.push("/");
      }
    });

    // Load Employees Paid Overtime Data
    axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "paidovertime/getByEmployee?empid=" + this.userId }).then(result => {
      console.log(result.data);
      this.overtimeData = result.data;
    }, error => {
      console.error(error);
      if (error.response.status == 401) {
        this.$router.push("/");
      }
    });

  }
};


</script>
